import { useCallback } from 'react';
import PropTypes from 'prop-types';
import ReorderItems from '../../../reorderItems';
import { reorder } from '../../../../../utility/helpers';
import LevelingTrack from './levelingTrack';

const LevelingTracks = ({
  translations,
  levelingTracks,
  levelingFramework,
  isReadOnly,
  isExpandedOnFirstOpen = false,
  canEdit = false,
  canDelete = false,
  onEditTrackTitle = () => {},
  onDuplicateTrack = () => {},
  handleDeleteTrackDialog = () => {},
  handleCreateLevel = () => {},
  onReorderLevel = () => {},
  onReorderTrack = () => {},
  handleMoveTrack = () => {},
  handleEditSalaries = () => {},
  toggleExpansion = () => {},
}) => {
  const handleReorder = useCallback(
    result => {
      if (
        !result.destination ||
        result.source.index === result.destination.index
      )
        return;

      const updatedOrder = reorder(
        levelingTracks,
        result.source.index,
        result.destination.index
      );

      return onReorderTrack(levelingFramework?.id, updatedOrder);
    },
    [levelingTracks, levelingFramework, onReorderTrack]
  );

  return (
    <div>
      <ReorderItems
        onSave={handleReorder}
        isDragDisabled={isReadOnly || !canEdit}
      >
        {levelingTracks.map(levelingTrack => (
          <LevelingTrack
            key={`track_group_${levelingTrack.id}`}
            id={levelingTrack.id}
            translations={translations}
            levelingFramework={levelingFramework}
            levelingTrack={levelingTrack}
            isReadOnly={isReadOnly}
            isExpandedOnFirstOpen={isExpandedOnFirstOpen}
            canEdit={canEdit}
            canDelete={canDelete}
            onEditTrackTitle={onEditTrackTitle}
            onDuplicateTrack={onDuplicateTrack}
            onReorderLevel={onReorderLevel}
            handleCreateLevel={handleCreateLevel}
            handleMoveTrack={handleMoveTrack}
            handleDeleteTrackDialog={handleDeleteTrackDialog}
            handleEditSalaries={handleEditSalaries}
            toggleExpansion={toggleExpansion}
          />
        ))}
      </ReorderItems>
    </div>
  );
};

LevelingTracks.propTypes = {
  translations: PropTypes.object.isRequired,
  levelingTracks: PropTypes.arrayOf(PropTypes.object).isRequired,
  levelingFramework: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  isExpandedOnFirstOpen: PropTypes.bool,
  onEditTrackTitle: PropTypes.func,
  onDuplicateTrack: PropTypes.func,
  handleEditSalaries: PropTypes.func,
  handleDeleteTrackDialog: PropTypes.func,
  onReorderLevel: PropTypes.func,
  onReorderTrack: PropTypes.func,
  handleCreateLevel: PropTypes.func,
  handleMoveTrack: PropTypes.func,
  toggleExpansion: PropTypes.func,
};

export default LevelingTracks;
